import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { initAnalytics } from '../lib/analytics';

const STORAGE_KEY = 'mtc-cookie-consent';
type Choice = 'accepted' | 'declined';

export function CookieBanner() {
  const [choice, setChoice] = useState<Choice | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Read once on mount; avoid SSR hydration drift if we ever add SSR.
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'accepted' || stored === 'declined') setChoice(stored);
    setMounted(true);
  }, []);

  if (!mounted || choice) return null;

  const decide = (next: Choice) => {
    localStorage.setItem(STORAGE_KEY, next);
    setChoice(next);
    // Start GA4 immediately on acceptance (no reload needed).
    if (next === 'accepted') initAnalytics();
  };

  return (
    <div
      role="dialog"
      aria-labelledby="mtc-cookie-banner-title"
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 60,
        maxWidth: 560,
        margin: '0 auto',
        background: '#0F1916',
        color: '#FBFAF6',
        borderRadius: 8,
        padding: '14px 16px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        alignItems: 'center',
        boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      <div style={{ flex: '1 1 240px', minWidth: 0, fontSize: 13, lineHeight: 1.45 }}>
        <strong id="mtc-cookie-banner-title" style={{ display: 'block', marginBottom: 4 }}>
          Cookies & confidentialité
        </strong>
        <span style={{ opacity: 0.85 }}>
          Nous utilisons des cookies essentiels pour le bon fonctionnement du site. Aucun traceur tiers
          n'est activé sans votre consentement.{' '}
          <Link to="/confidentialite" style={{ color: '#FBFAF6', textDecoration: 'underline' }}>
            En savoir plus
          </Link>
          .
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          onClick={() => decide('declined')}
          style={{
            background: 'transparent',
            color: '#FBFAF6',
            border: '1px solid rgba(255,255,255,0.3)',
            padding: '8px 12px',
            borderRadius: 6,
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          Refuser
        </button>
        <button
          type="button"
          onClick={() => decide('accepted')}
          style={{
            background: '#0B5D3B',
            color: '#FBFAF6',
            border: 0,
            padding: '8px 14px',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Accepter
        </button>
      </div>
    </div>
  );
}
